import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { ShopItemType } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Dialog } from '@sorare/core/src/components/dialog';
import { isType } from '@sorare/core/src/lib/gql';

import { DefaultContent } from './Content/DefaultContent';
import { LogoContent } from './Content/LogoContent';
import { SkinContent } from './Content/SkinContent';
import type { ItemPreviewDialog_shopItem } from './__generated__/index.graphql';

const Body = styled(Vertical).attrs({ gap: 3 })`
  padding: var(--triple-unit);
`;

type DialogContentProps = {
  item: ItemPreviewDialog_shopItem;
  itemEquipped?: boolean;
  onSelect?: () => void;
};
const DialogContent = ({
  item,
  itemEquipped,
  onSelect,
}: DialogContentProps) => {
  if (isType(item, 'SkinShopItem')) {
    if (item.position === ShopItemType.LOGO) {
      return <LogoContent item={item} onSelect={onSelect} />;
    }

    return (
      <SkinContent
        item={item}
        itemEquipped={itemEquipped}
        onSelect={onSelect}
      />
    );
  }

  return <DefaultContent item={item} />;
};

type Props = {
  open: boolean;
  onSelect?: () => void;
  item: ItemPreviewDialog_shopItem;
  itemEquipped?: boolean;
  onClose: () => void;
};
export const ItemPreviewDialog = ({
  open,
  item,
  onClose,
  itemEquipped,
  onSelect,
}: Props) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
      <Body>
        <DialogContent
          item={item}
          itemEquipped={itemEquipped}
          onSelect={onSelect}
        />
      </Body>
    </Dialog>
  );
};

ItemPreviewDialog.fragments = {
  shopItem: gql`
    fragment ItemPreviewDialog_shopItem on ClubShopItem {
      ... on ShopItemInterface {
        id
      }
      ...LogoContent_clubShopItem
      ...SkinContent_clubShopItem
      ...DefaultContent_clubShopItem
    }
    ${LogoContent.fragments.clubShopItem}
    ${SkinContent.fragments.clubShopItem}
    ${DefaultContent.fragments.clubShopItem}
  ` as TypedDocumentNode<ItemPreviewDialog_shopItem>,
};
